/*!
 * froala_editor v4.6.2 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(require("froala-editor")) : "function" == typeof define && define.amd ? define(["froala-editor"], t) : t(e.FroalaEditor);
}(this, function (Me) {
  "use strict";

  function r(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var a = 0, i = Array(t); a < t; a++) i[a] = e[a];
    return i;
  }
  function Ke(e, t) {
    var a = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!a) {
      if (Array.isArray(e) || (a = l(e)) || t && e && "number" == typeof e.length) {
        a && (e = a);
        var i = 0,
          r = function () {};
        return {
          s: r,
          n: function () {
            return i >= e.length ? {
              done: !0
            } : {
              done: !1,
              value: e[i++]
            };
          },
          e: function (e) {
            throw e;
          },
          f: r
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var n,
      o = !0,
      s = !1;
    return {
      s: function () {
        a = a.call(e);
      },
      n: function () {
        var e = a.next();
        return o = e.done, e;
      },
      e: function (e) {
        s = !0, n = e;
      },
      f: function () {
        try {
          o || null == a["return"] || a["return"]();
        } finally {
          if (s) throw n;
        }
      }
    };
  }
  function Ye(e) {
    return function t(e) {
      if (Array.isArray(e)) return r(e);
    }(e) || function a(e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || l(e) || function i() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function We(e) {
    return (We = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function l(e, t) {
    if (e) {
      if ("string" == typeof e) return r(e, t);
      var a = {}.toString.call(e).slice(8, -1);
      return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Array.from(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? r(e, t) : void 0;
    }
  }
  Me = Me && Me.hasOwnProperty("default") ? Me["default"] : Me, Object.assign(Me.POPUP_TEMPLATES, {
    "image.insert": "[_BUTTONS_][_UPLOAD_LAYER_][_BY_URL_LAYER_][_PROGRESS_BAR_]",
    "image.edit": "[_BUTTONS_]",
    "image.alt": "[_BUTTONS_][_ALT_LAYER_]",
    "image.size": "[_BUTTONS_][_SIZE_LAYER_]"
  }), Object.assign(Me.DEFAULTS, {
    imageInsertButtons: ["imageBack", "|", "imageUpload", "imageByURL"],
    imageEditButtons: ["imageReplace", "imageAlign", "imageCaption", "imageRemove", "imageLink", "linkOpen", "linkEdit", "linkRemove", "-", "imageDisplay", "imageStyle", "imageAlt", "imageSize"],
    imageAltButtons: ["imageBack", "|"],
    imageSizeButtons: ["imageBack", "|"],
    imageUpload: !0,
    imageUploadURL: null,
    imageCORSProxy: "https://cors-anywhere.froala.com",
    imageUploadRemoteUrls: !0,
    imageUploadParam: "file",
    imageUploadParams: {},
    imageUploadToS3: !1,
    imageUploadToAzure: !1,
    imageUploadMethod: "POST",
    imageMaxSize: 10485760,
    imageAllowedTypes: ["jpeg", "jpg", "png", "gif", "webp"],
    imageResize: !0,
    imageResizeWithPercent: !1,
    imageRoundPercent: !1,
    imageDefaultWidth: 300,
    imageDefaultAlign: "center",
    imageDefaultDisplay: "block",
    imageSplitHTML: !1,
    imageStyles: {
      "fr-rounded": "Rounded",
      "fr-bordered": "Bordered",
      "fr-shadow": "Shadow"
    },
    imageMove: !0,
    imageMultipleStyles: !0,
    imageTextNear: !0,
    imagePaste: !0,
    imagePasteProcess: !1,
    imageMinWidth: 16,
    imageOutputSize: !1,
    imageDefaultMargin: 5,
    imageAddNewLine: !1
  }), Me.IMAGE_ALLOW_REGEX = /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i, Me.PLUGINS.image = function (R) {
    var U,
      p,
      f,
      g,
      c,
      a,
      A = R.$,
      C = "https://i.froala.com/upload",
      t = !1,
      i = 1,
      d = 2,
      u = 3,
      m = 4,
      S = 5,
      E = 6,
      r = {};
    function h() {
      var e = R.popups.get("image.insert").find(".fr-image-by-url-layer input");
      e.val(""), U && e.val(U.attr("src")), e.trigger("change");
    }
    function o(e) {
      return window.pageYOffset + e.get(0).getBoundingClientRect().top;
    }
    function n() {
      var e = R.popups.get("image.edit");
      if (e || (e = N()), e) {
        var t = U;
        R.popups.setContainer("image.edit", R.$wp || R.$sc), R.popups.refresh("image.edit");
        var a = t.offset().left + t.outerWidth() / 2,
          i = t && o(t),
          r = R.$wp && o(R.$wp);
        r || (r = i);
        var n = 0;
        R.opts.iframe ? ((n = R.$wp.scrollTop() + e.outerHeight()) < t.get(0).getBoundingClientRect().top && (n = t.get(0).getBoundingClientRect().top), n > t.get(0).getBoundingClientRect().top + t.height() && (n = t.get(0).getBoundingClientRect().top + t.height())) : n = r < i ? i : R.$wp && i + t.height() < r + R.$wp.height() ? i + t.height() : r + e.outerHeight(), U.hasClass("fr-uploading") ? P() : R.popups.show("image.edit", a, n, 1, !0);
      }
    }
    function v() {
      k();
    }
    function s(e) {
      0 < e.parents(".fr-img-caption").length && (e = e.parents(".fr-img-caption").first());
      var t = e.hasClass("fr-dib") ? "block" : e.hasClass("fr-dii") ? "inline" : null,
        a = e.hasClass("fr-fil") ? "left" : e.hasClass("fr-fir") ? "right" : ve(e);
      he(e, t, a), e.removeClass("fr-dib fr-dii fr-fir fr-fil");
    }
    function l() {
      for (var e, t = "IMG" == R.el.tagName ? [R.el] : R.el.querySelectorAll("img"), a = 0; a < t.length; a++) {
        var i = A(t[a]);
        !R.opts.htmlUntouched && R.opts.useClasses ? ((R.opts.imageDefaultAlign || R.opts.imageDefaultDisplay) && (0 < (e = i).parents(".fr-img-caption").length && (e = e.parents(".fr-img-caption").first()), e.hasClass("fr-dii") || e.hasClass("fr-dib") || (e.addClass("fr-fi".concat(ve(e)[0])), e.addClass("fr-di".concat(be(e)[0])), e.css("margin", ""), e.css("float", ""), e.css("display", ""), e.css("z-index", ""), e.css("position", ""), e.css("overflow", ""), e.css("vertical-align", ""))), R.opts.imageTextNear || (0 < i.parents(".fr-img-caption").length ? i.parents(".fr-img-caption").first().removeClass("fr-dii").addClass("fr-dib") : i.removeClass("fr-dii").addClass("fr-dib"))) : R.opts.htmlUntouched || R.opts.useClasses || (R.opts.imageDefaultAlign || R.opts.imageDefaultDisplay) && s(i), R.opts.iframe && i.on("load", R.size.syncIframe);
      }
    }
    function b(e) {
      void 0 === e && (e = !0);
      var t,
        a = Array.prototype.slice.call(R.el.querySelectorAll("img")),
        i = [];
      for (t = 0; t < a.length; t++) if (i.push(a[t].getAttribute("src")), A(a[t]).toggleClass("fr-draggable", R.opts.imageMove), "" === a[t].getAttribute("class") && a[t].removeAttribute("class"), "" === a[t].getAttribute("style") && a[t].removeAttribute("style"), a[t].parentNode && a[t].parentNode.parentNode && R.node.hasClass(a[t].parentNode.parentNode, "fr-img-caption")) {
        var r = a[t].parentNode.parentNode;
        R.browser.mozilla || r.setAttribute("contenteditable", !1), r.setAttribute("draggable", !1), r.classList.add("fr-draggable");
        var n = a[t].nextSibling;
        n && !R.browser.mozilla && n.setAttribute("contenteditable", !0);
      }
      if (c) for (t = 0; t < c.length; t++) i.indexOf(c[t].getAttribute("src")) < 0 && R.events.trigger("image.removed", [A(c[t])]);
      if (c && e) {
        var o = [];
        for (t = 0; t < c.length; t++) o.push(c[t].getAttribute("src"));
        for (t = 0; t < a.length; t++) o.indexOf(a[t].getAttribute("src")) < 0 && R.events.trigger("image.loaded", [A(a[t])]);
      }
      c = a;
    }
    function x() {
      if (p || function o() {
        var e;
        R.shared.$image_resizer ? (p = R.shared.$image_resizer, g = R.shared.$img_overlay, R.events.on("destroy", function () {
          A("body").first().append(p.removeClass("fr-active"));
        }, !0)) : (R.shared.$image_resizer = A(document.createElement("div")).attr("class", "fr-image-resizer"), p = R.shared.$image_resizer, R.events.$on(p, "mousedown", function (e) {
          e.stopPropagation();
        }, !0), R.opts.imageResize && (p.append(y("nw") + y("ne") + y("sw") + y("se")), R.shared.$img_overlay = A(document.createElement("div")).attr("class", "fr-image-overlay"), g = R.shared.$img_overlay, e = p.get(0).ownerDocument, A(e).find("body").first().append(g)));
        R.events.on("shared.destroy", function () {
          p.html("").removeData().remove(), p = null, R.opts.imageResize && (g.remove(), g = null);
        }, !0), R.helpers.isMobile() || R.events.$on(A(R.o_win), "resize", function () {
          U && !U.hasClass("fr-uploading") ? ce(!0) : U && (x(), ye(), P(!1));
        });
        if (R.opts.imageResize) {
          e = p.get(0).ownerDocument, R.events.$on(p, R._mousedown, ".fr-handler", D), R.events.$on(A(e), R._mousemove, T), R.events.$on(A(e.defaultView || e.parentWindow), R._mouseup, $), R.events.$on(g, "mouseleave", $);
          var i = 1,
            r = null,
            n = 0;
          R.events.on("keydown", function (e) {
            if (U) {
              var t = -1 != navigator.userAgent.indexOf("Mac OS X") ? e.metaKey : e.ctrlKey,
                a = e.which;
              (a !== r || 200 < e.timeStamp - n) && (i = 1), (a == Me.KEYCODE.EQUALS || R.browser.mozilla && a == Me.KEYCODE.FF_EQUALS) && t && !e.altKey ? i = te.call(this, e, 1, 1, i) : (a == Me.KEYCODE.HYPHEN || R.browser.mozilla && a == Me.KEYCODE.FF_HYPHEN) && t && !e.altKey ? i = te.call(this, e, 2, -1, i) : R.keys.ctrlKey(e) || a != Me.KEYCODE.ENTER || (U.before("<br>"), z(U)), r = a, n = e.timeStamp;
            }
          }, !0), R.events.on("keyup", function () {
            i = 1;
          });
        }
      }(), !U) return !1;
      var e = R.$wp || R.$sc;
      e.append(p), p.data("instance", R);
      var t = e.scrollTop() - ("static" != e.css("position") ? e.offset().top : 0),
        a = e.scrollLeft() - ("static" != e.css("position") ? e.offset().left : 0);
      a -= R.helpers.getPX(e.css("border-left-width")), t -= R.helpers.getPX(e.css("border-top-width")), R.$el.is("img") && R.$sc.is("body") && (a = t = 0);
      var i = Ce();
      Se() && (i = i.find(".fr-img-wrap"));
      var r = 0,
        n = 0;
      R.opts.iframe && (r = R.helpers.getPX(R.$wp.find(".fr-iframe").css("padding-top")), n = R.helpers.getPX(R.$wp.find(".fr-iframe").css("padding-left"))), p.css("top", (R.opts.iframe ? i.offset().top + r : i.offset().top + t) - 1).css("left", (R.opts.iframe ? i.offset().left + n : i.offset().left + a) - 1).css("width", i.get(0).getBoundingClientRect().width).css("height", i.get(0).getBoundingClientRect().height).addClass("fr-active");
    }
    function y(e) {
      return '<div class="fr-handler fr-h'.concat(e, '"></div>');
    }
    function w(e) {
      Se() && U.parents(".fr-img-caption").css("width", e), U.css("width", e);
    }
    function D(e) {
      if (!R.core.sameInstance(p)) return !0;
      if (e.preventDefault(), e.stopPropagation(), R.$el.find("img.fr-error").left) return !1;
      R.undo.canDo() || R.undo.saveStep();
      var t = e.pageX || e.originalEvent.touches[0].pageX;
      if ("mousedown" == e.type) {
        var a = R.$oel.get(0),
          i = a.ownerDocument,
          r = i.defaultView || i.parentWindow,
          n = !1;
        try {
          n = r.location != r.parent.location && !(r.$ && r.$.FE);
        } catch (l) {}
        n && r.frameElement && (t += R.helpers.getPX(A(a).offset().left) + r.frameElement.clientLeft);
      }
      (f = A(this)).data("start-x", t), f.data("start-width", U.width()), f.data("start-height", U.height());
      var o = U.width();
      if (R.opts.imageResizeWithPercent) {
        var s = U.parentsUntil(R.$el, R.html.blockTagsQuery()).get(0) || R.el;
        o = (o / A(s).outerWidth() * 100).toFixed(2) + "%";
      }
      w(o), g.show(), R.popups.hideAll(), me();
    }
    function T(e) {
      if (!R.core.sameInstance(p)) return !0;
      var t;
      if (f && U) {
        if (e.preventDefault(), R.$el.find("img.fr-error").left) return !1;
        var a = e.pageX || (e.originalEvent.touches ? e.originalEvent.touches[0].pageX : null);
        if (!a) return !1;
        var i = a - f.data("start-x"),
          r = f.data("start-width");
        if ((f.hasClass("fr-hnw") || f.hasClass("fr-hsw")) && (i = 0 - i), R.opts.imageResizeWithPercent) {
          var n = U.parentsUntil(R.$el, R.html.blockTagsQuery()).get(0) || R.el;
          r = ((r + i) / A(n).outerWidth() * 100).toFixed(2), R.opts.imageRoundPercent && (r = Math.round(r)), w("".concat(r, "%")), (t = Se() ? (R.helpers.getPX(U.parents(".fr-img-caption").css("width")) / A(n).outerWidth() * 100).toFixed(2) : (R.helpers.getPX(U.css("width")) / A(n).outerWidth() * 100).toFixed(2)) === r || R.opts.imageRoundPercent || w("".concat(t, "%")), U.css("height", "").removeAttr("height");
        } else r + i >= R.opts.imageMinWidth && (w(r + i), t = Se() ? R.helpers.getPX(U.parents(".fr-img-caption").css("width")) : R.helpers.getPX(U.css("width"))), t !== r + i && w(t), ((U.attr("style") || "").match(/(^height:)|(; *height:)/) || U.attr("height")) && (U.css("height", f.data("start-height") * U.width() / f.data("start-width")), U.removeAttr("height"));
        x(), R.events.trigger("image.resize", [Ae()]);
      }
    }
    function $(e) {
      if (!R.core.sameInstance(p)) return !0;
      if (f && U) {
        if (e && e.stopPropagation(), R.$el.find("img.fr-error").left) return !1;
        f = null, g.hide(), x(), n(), R.undo.saveStep(), R.events.trigger("image.resizeEnd", [Ae()]);
      } else p.removeClass("fr-active");
    }
    function I(e, t, a) {
      R.edit.on(), U && U.addClass("fr-error"), r[e] ? O(R.language.translate(r[e])) : O(R.language.translate("Something went wrong. Please try again.")), !U && a && ae(a), R.events.trigger("image.error", [{
        code: e,
        message: r[e]
      }, t, a]);
    }
    function N(e) {
      if (e) return R.$wp && R.events.$on(R.$wp, "scroll.image-edit", function () {
        U && R.popups.isVisible("image.edit") && (R.events.disableBlur(), n());
      }), !0;
      var t = "";
      if (0 < R.opts.imageEditButtons.length) {
        var a = {
          buttons: t += '<div class="fr-buttons">\n        '.concat(R.button.buildList(R.opts.imageEditButtons), "\n        </div>")
        };
        return R.popups.create("image.edit", a);
      }
      return !1;
    }
    function P(e) {
      var t = R.popups.get("image.insert");
      if (t || (t = X()), t.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"), t.find(".fr-image-progress-bar-layer").addClass("fr-active"), t.find(".fr-buttons").hide(), U) {
        var a = Ce();
        R.popups.setContainer("image.insert", R.$sc);
        var i = a.offset().left,
          r = a.offset().top + a.height();
        R.popups.show("image.insert", i, r, a.outerHeight());
      }
      void 0 === e && B(R.language.translate("Uploading"), 0);
    }
    function k(e) {
      var t = R.popups.get("image.insert");
      if (t && (t.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"), t.find(".fr-image-progress-bar-layer").removeClass("fr-active"), t.find(".fr-buttons").show(), e || R.$el.find("img.fr-error").length)) {
        if (R.events.focus(), R.$el.find("img.fr-error").length && (R.$el.find("img.fr-error").remove(), R.undo.saveStep(), R.undo.run(), R.undo.dropRedo()), !R.$wp && U) {
          var a = U;
          ce(!0), R.selection.setAfter(a.get(0)), R.selection.restore();
        }
        R.popups.hide("image.insert");
      }
    }
    function B(e, t) {
      var a = R.popups.get("image.insert");
      if (a) {
        var i = a.find(".fr-image-progress-bar-layer");
        i.find("h3").text(e + (t ? " ".concat(t, "%") : "")), i.removeClass("fr-error"), t ? (i.find("div").removeClass("fr-indeterminate"), i.find("div > span").css("width", "".concat(t, "%"))) : i.find("div").addClass("fr-indeterminate");
      }
    }
    function O(e) {
      P();
      var t = R.popups.get("image.insert").find(".fr-image-progress-bar-layer");
      t.addClass("fr-error");
      var a = t.find("h3");
      a.text(e), R.events.disableBlur(), a.focus();
    }
    function z(e) {
      ge.call(e.get(0));
    }
    function L() {
      var e = A(this);
      R.popups.hide("image.insert"), e.removeClass("fr-uploading"), e.next().is("br") && e.next().remove(), z(e), R.events.trigger("image.loaded", [e]);
    }
    function _(s, e, l, p, f) {
      p && "string" == typeof p && (p = R.$(p)), R.edit.off(), B(R.language.translate("Loading image")), e && (s = R.helpers.sanitizeURL(s));
      var t = new Image();
      t.onload = function () {
        var e, t;
        if (p) {
          R.undo.canDo() || p.hasClass("fr-uploading") || R.undo.saveStep();
          var a = p.data("fr-old-src");
          if (p.data("fr-image-pasted") && (a = null), R.$wp) {
            (e = p.clone().removeData("fr-old-src").removeClass("fr-uploading").removeAttr("data-fr-image-pasted")).off("load"), a && p.attr("src", a), !R.opts.trackChangesEnabled || p[0].parentNode && "SPAN" === p[0].parentNode.tagName && p[0].parentNode.hasAttribute("data-tracking") || R.track_changes.replaceSpecialItem(p);
            var i = c.indexOf(p[0]);
            0 <= i && (c[i] = e[0]), p.replaceWith(e);
          } else e = p;
          for (var r = e.get(0).attributes, n = 0; n < r.length; n++) {
            var o = r[n];
            0 === o.nodeName.indexOf("data-") && "data-pasted" !== o.nodeName ? e.removeAttr(o.nodeName) : l && l.hasOwnProperty(o.nodeName) && e.removeAttr(o.nodeName);
          }
          if (void 0 !== l) for (t in l) l.hasOwnProperty(t) && "link" != t && e.attr("".concat(t), l[t]);
          e.on("load", L), e.attr("src", s), R.edit.on(), b(!1), p[0].src != s && R.selection.restore(), R.undo.saveStep(), R.events.disableBlur(), R.$el.blur(), R.events.trigger(a ? "image.replaced" : "image.inserted", [e, f]);
        } else (e = W(s, l, L)) && (b(!1), R.undo.saveStep(), R.events.disableBlur(), R.$el.blur(), R.events.trigger("image.inserted", [e, f]));
      }, t.onerror = function () {
        I(i);
      }, P(R.language.translate("Loading image")), t.src = s;
    }
    function M(e, t, a) {
      B(R.language.translate("Loading image"));
      var i = this.status,
        r = this.response,
        n = this.responseXML,
        o = this.responseText;
      try {
        if (R.opts.imageUploadToS3 || R.opts.imageUploadToAzure) {
          if (201 == i) {
            var s;
            if (R.opts.imageUploadToAzure) {
              if (!1 === R.events.trigger("image.uploadedToAzure", [this.responseURL, a, r], !0)) return R.edit.on(), !1;
              s = t;
            } else s = function p(e) {
              try {
                var t = A(e).find("Location").text(),
                  a = A(e).find("Key").text();
                return !1 === R.events.trigger("image.uploadedToS3", [t, a, e], !0) ? (R.edit.on(), !1) : t;
              } catch (i) {
                return I(m, e), !1;
              }
            }(n);
            s && _(s, !1, [], e, r || n);
          } else I(m, r || n, e);
        } else if (200 <= i && i < 300) {
          var l = function f(e) {
            try {
              if (!1 === R.events.trigger("image.uploaded", [e], !0)) return R.edit.on(), !1;
              var t = JSON.parse(e);
              return t.link ? t : (I(d, e), !1);
            } catch (a) {
              return I(m, e), !1;
            }
          }(o);
          l && _(l.link, !1, l, e, r || o);
        } else I(u, r || o, e);
      } catch (g) {
        I(m, r || o, e);
      }
    }
    function K() {
      I(m, this.response || this.responseText || this.responseXML);
    }
    function Y(e) {
      if (e.lengthComputable) {
        var t = e.loaded / e.total * 100 | 0;
        B(R.language.translate("Uploading"), t);
      }
    }
    function W(e, t, a) {
      var i,
        r = A(document.createElement("img")).attr("src", e);
      if (t && void 0 !== t) for (i in t) t.hasOwnProperty(i) && "link" != i && (" data-".concat(i, '="').concat(t[i], '"'), r.attr("".concat(i), t[i]));
      var n = R.opts.imageDefaultWidth;
      n && "auto" != n && (n = R.opts.imageResizeWithPercent ? "100%" : "".concat(n, "px")), r.attr("style", n ? "width: ".concat(n, ";") : ""), he(r, R.opts.imageDefaultDisplay, R.opts.imageDefaultAlign), r.on("load", a), r.on("error", a), R.edit.on(), R.events.focus(!0), R.selection.restore(), R.undo.saveStep(), R.opts.imageSplitHTML ? R.markers.split() : R.markers.insert(), R.html.wrap();
      var o = R.$el.find(".fr-marker");
      if (o.length) (o.parent().is("hr") || o.parent().is("IMG")) && o.parent().after(o), R.node.isLastSibling(o) && o.parent().hasClass("fr-deletable") && o.insertAfter(o.parent()), o.replaceWith(r);else {
        if (R.opts.trackChangesEnabled) return k(!0), !1;
        R.$el.append(r);
      }
      return R.selection.clear(), r;
    }
    function G() {
      R.edit.on(), k(!0);
    }
    function H(e, t) {
      if (void 0 !== e && 0 < e.length) {
        if (!1 === R.events.trigger("image.beforeUpload", [e, t])) return !1;
        var a,
          i = e[0];
        if (!(null !== R.opts.imageUploadURL && R.opts.imageUploadURL != C || R.opts.imageUploadToS3 || R.opts.imageUploadToAzure)) return function y(r, n) {
          var o = new FileReader();
          o.onload = function () {
            var e = o.result;
            if (o.result.indexOf("svg+xml") < 0) {
              for (var t = atob(o.result.split(",")[1]), a = [], i = 0; i < t.length; i++) a.push(t.charCodeAt(i));
              e = window.URL.createObjectURL(new Blob([new Uint8Array(a)], {
                type: r.type
              })), n && n.data("fr-old-src", n.attr("src")), R.image.insert(e, !1, null, n);
            } else R.image.insert(e, null, null, R.image.get());
          }, P(), o.readAsDataURL(r);
        }(i, t || U), !1;
        if (i.name || (i.name = new Date().getTime() + "." + (i.type || "image/jpeg").replace(/image\//g, "")), i.size > R.opts.imageMaxSize) return I(S), !1;
        if (R.opts.imageAllowedTypes.indexOf(i.type.replace(/image\//g, "")) < 0) return I(E), !1;
        if (R.drag_support.formdata && (a = R.drag_support.formdata ? new FormData() : null), a) {
          var r;
          if (!1 !== R.opts.imageUploadToS3) for (r in a.append("key", R.opts.imageUploadToS3.keyStart + new Date().getTime() + "-" + (i.name || "untitled")), a.append("success_action_status", "201"), a.append("X-Requested-With", "xhr"), a.append("Content-Type", i.type), R.opts.imageUploadToS3.params) R.opts.imageUploadToS3.params.hasOwnProperty(r) && a.append(r, R.opts.imageUploadToS3.params[r]);
          for (r in R.opts.imageUploadParams) R.opts.imageUploadParams.hasOwnProperty(r) && a.append(r, R.opts.imageUploadParams[r]);
          a.append(R.opts.imageUploadParam, i, i.name);
          var n,
            o,
            s = R.opts.imageUploadURL,
            l = R.opts.imageUploadMethod;
          R.opts.imageUploadToS3 && (s = R.opts.imageUploadToS3.uploadURL ? R.opts.imageUploadToS3.uploadURL : "https://".concat(R.opts.imageUploadToS3.region, ".amazonaws.com/").concat(R.opts.imageUploadToS3.bucket)), R.opts.imageUploadToAzure && (n = s = R.opts.imageUploadToAzure.uploadURL ? "".concat(R.opts.imageUploadToAzure.uploadURL, "/").concat(i.name) : encodeURI("https://".concat(R.opts.imageUploadToAzure.account, ".blob.core.windows.net/").concat(R.opts.imageUploadToAzure.container, "/").concat(i.name)), R.opts.imageUploadToAzure.SASToken && (s += R.opts.imageUploadToAzure.SASToken), l = "PUT");
          var p = R.core.getXHR(s, l);
          if (R.opts.imageUploadToAzure) {
            var f = new Date().toUTCString();
            if (!R.opts.imageUploadToAzure.SASToken && R.opts.imageUploadToAzure.accessKey) {
              var g = R.opts.imageUploadToAzure.account,
                c = R.opts.imageUploadToAzure.container;
              if (R.opts.imageUploadToAzure.uploadURL) {
                var d = R.opts.imageUploadToAzure.uploadURL.split("/");
                c = d.pop(), g = d.pop().split(".")[0];
              }
              var u = "x-ms-blob-type:BlockBlob\nx-ms-date:".concat(f, "\nx-ms-version:2019-07-07"),
                m = encodeURI("/" + g + "/" + c + "/" + i.name),
                h = l + "\n\n\n" + i.size + "\n\n" + i.type + "\n\n\n\n\n\n\n" + u + "\n" + m,
                v = R.cryptoJSPlugin.cryptoJS.HmacSHA256(h, R.cryptoJSPlugin.cryptoJS.enc.Base64.parse(R.opts.imageUploadToAzure.accessKey)).toString(R.cryptoJSPlugin.cryptoJS.enc.Base64),
                b = "SharedKey " + g + ":" + v;
              o = v, p.setRequestHeader("Authorization", b);
            }
            for (r in p.setRequestHeader("x-ms-version", "2019-07-07"), p.setRequestHeader("x-ms-date", f), p.setRequestHeader("Content-Type", i.type), p.setRequestHeader("x-ms-blob-type", "BlockBlob"), R.opts.imageUploadParams) R.opts.imageUploadParams.hasOwnProperty(r) && p.setRequestHeader(r, R.opts.imageUploadParams[r]);
            for (r in R.opts.imageUploadToAzure.params) R.opts.imageUploadToAzure.params.hasOwnProperty(r) && p.setRequestHeader(r, R.opts.imageUploadToAzure.params[r]);
          }
          !function w(t, a, i, r, n, o) {
            function s() {
              var e = A(this);
              e.off("load"), e.addClass("fr-uploading"), e.next().is("br") && e.next().remove(), R.placeholder.refresh(), z(e), x(), P(), R.edit.off(), t.onload = function () {
                M.call(t, e, n, o);
              }, t.onerror = K, t.upload.onprogress = Y, t.onabort = G, A(e.off("abortUpload")).on("abortUpload", function () {
                4 != t.readyState && (t.abort(), r ? (r.attr("src", r.data("fr-old-src")), r.removeClass("fr-uploading")) : e.remove(), ce(!0));
              }), t.send(R.opts.imageUploadToAzure ? i : a);
            }
            var l = new FileReader();
            l.onload = function () {
              var e = l.result;
              if (l.result.indexOf("svg+xml") < 0) {
                for (var t = atob(l.result.split(",")[1]), a = [], i = 0; i < t.length; i++) a.push(t.charCodeAt(i));
                e = window.URL.createObjectURL(new Blob([new Uint8Array(a)], {
                  type: "image/jpeg"
                }));
              }
              r ? (r.on("load", s), r.on("error", function () {
                s(), A(this).off("error");
              }), R.edit.on(), R.undo.saveStep(), r.data("fr-old-src", r.attr("src")), r.attr("src", e)) : W(e, null, s);
            }, l.readAsDataURL(i);
          }(p, a, i, t || U, n, o);
        }
      }
    }
    function F(e) {
      if (e.is("img") && 0 < e.parents(".fr-img-caption").length) return e.parents(".fr-img-caption");
    }
    function V(e) {
      var t = e.originalEvent.dataTransfer;
      if (t && t.files && t.files.length) {
        var a = t.files[0];
        if (a && a.type && -1 !== a.type.indexOf("image") && 0 <= R.opts.imageAllowedTypes.indexOf(a.type.replace(/image\//g, ""))) {
          if (!R.opts.imageUpload) return e.preventDefault(), e.stopPropagation(), !1;
          R.markers.remove(), R.markers.insertAtPoint(e.originalEvent), R.$el.find(".fr-marker").replaceWith(Me.MARKERS), 0 === R.$el.find(".fr-marker").length && R.selection.setAtEnd(R.el), R.popups.hideAll();
          var i = R.popups.get("image.insert");
          i || (i = X()), R.popups.setContainer("image.insert", R.$sc);
          var r = e.originalEvent.pageX,
            n = e.originalEvent.pageY;
          if (R.opts.iframe) {
            var o = R.helpers.getPX(R.$wp.find(".fr-iframe").css("padding-top")),
              s = R.helpers.getPX(R.$wp.find(".fr-iframe").css("padding-left"));
            n += R.$iframe.offset().top + o, r += R.$iframe.offset().left + s;
          }
          return R.popups.show("image.insert", r, n), P(), 0 <= R.opts.imageAllowedTypes.indexOf(a.type.replace(/image\//g, "")) ? (ce(!0), H(t.files)) : I(E), e.preventDefault(), e.stopPropagation(), !1;
        }
      }
    }
    function X(e) {
      if (e) return R.popups.onRefresh("image.insert", h), R.popups.onHide("image.insert", v), !0;
      var t,
        a,
        i = "";
      R.opts.imageUpload || -1 === R.opts.imageInsertButtons.indexOf("imageUpload") || R.opts.imageInsertButtons.splice(R.opts.imageInsertButtons.indexOf("imageUpload"), 1);
      var r = R.button.buildList(R.opts.imageInsertButtons);
      "" !== r && (i = '<div class="fr-buttons fr-tabs">'.concat(r, "</div>"));
      var n = R.opts.imageInsertButtons.indexOf("imageUpload"),
        o = R.opts.imageInsertButtons.indexOf("imageByURL"),
        s = "";
      0 <= n && (t = " fr-active", 0 <= o && o < n && (t = ""), s = '<div class="fr-image-upload-layer'.concat(t, ' fr-layer" id="fr-image-upload-layer-').concat(R.id, '"><strong>').concat(R.language.translate("Drop image"), "</strong><br>(").concat(R.language.translate("or click"), ')<div class="fr-form"><input type="file" accept="image/').concat(R.opts.imageAllowedTypes.join(", image/").toLowerCase(), '" tabIndex="-1" aria-labelledby="fr-image-upload-layer-').concat(R.id, '" role="button"></div></div>'));
      var l = "";
      0 <= o && (t = " fr-active", 0 <= n && n < o && (t = ""), l = '<div class="fr-image-by-url-layer'.concat(t, ' fr-layer" id="fr-image-by-url-layer-').concat(R.id, '"><div class="fr-input-line"><input id="fr-image-by-url-layer-text-').concat(R.id, '" type="text" placeholder="http://" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageInsertByURL" tabIndex="2" role="button">').concat(R.language.translate("Insert"), "</button></div></div>"));
      var p = {
        buttons: i,
        upload_layer: s,
        by_url_layer: l,
        progress_bar: '<div class="fr-image-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="imageDismissError" tabIndex="2" role="button">OK</button></div></div>'
      };
      return 1 <= R.opts.imageInsertButtons.length && (a = R.popups.create("image.insert", p)), R.$wp && R.events.$on(R.$wp, "scroll", function () {
        U && R.popups.isVisible("image.insert") && ye();
      }), function f(i) {
        R.events.$on(i, "dragover dragenter", ".fr-image-upload-layer", function (e) {
          return A(this).addClass("fr-drop"), (R.browser.msie || R.browser.edge) && e.preventDefault(), !1;
        }, !0), R.events.$on(i, "dragleave dragend", ".fr-image-upload-layer", function (e) {
          return A(this).removeClass("fr-drop"), (R.browser.msie || R.browser.edge) && e.preventDefault(), !1;
        }, !0), R.events.$on(i, "drop", ".fr-image-upload-layer", function (e) {
          e.preventDefault(), e.stopPropagation(), A(this).removeClass("fr-drop");
          var t = e.originalEvent.dataTransfer;
          if (t && t.files) {
            var a = i.data("instance") || R;
            a.events.disableBlur(), a.image.upload(t.files), a.events.enableBlur();
          }
        }, !0), R.helpers.isIOS() && R.events.$on(i, "touchstart", '.fr-image-upload-layer input[type="file"]', function () {
          A(this).trigger("click");
        }, !0), R.events.$on(i, "change", '.fr-image-upload-layer input[type="file"]', function () {
          if (this.files) {
            var e = i.data("instance") || R;
            e.events.disableBlur(), i.find("input:focus").blur(), e.events.enableBlur(), e.image.upload(this.files, U);
          }
          A(this).val("");
        }, !0);
      }(a), a;
    }
    function q() {
      U && R.popups.get("image.alt").find("input").val(U.attr("alt") || "").trigger("change");
    }
    function j() {
      var e = R.popups.get("image.alt");
      e || (e = J()), k(), R.popups.refresh("image.alt"), R.popups.setContainer("image.alt", R.$sc);
      var t = Ce(),
        a = t.outerWidth() / 2;
      Se() && (t = t.find(".fr-img-wrap"), a = U.outerWidth() / 2);
      var i = t.offset().left + a,
        r = t.offset().top + t.outerHeight(),
        n = t.outerHeight();
      R.opts.iframe && Se() && (n = U ? U.outerHeight() : 0), R.popups.show("image.alt", i, r, n, !0);
    }
    function J(e) {
      if (e) return R.popups.onRefresh("image.alt", q), !0;
      var t = {
          buttons: '<div class="fr-buttons fr-tabs">'.concat(R.button.buildList(R.opts.imageAltButtons), "</div>"),
          alt_layer: '<div class="fr-image-alt-layer fr-layer fr-active" id="fr-image-alt-layer-'.concat(R.id, '"><div class="fr-input-line"><input id="fr-image-alt-layer-text-').concat(R.id, '" type="text" placeholder="').concat(R.language.translate("Alternative Text"), '" tabIndex="1"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetAlt" tabIndex="2" role="button">').concat(R.language.translate("Update"), "</button></div></div>")
        },
        a = R.popups.create("image.alt", t);
      return R.$wp && R.events.$on(R.$wp, "scroll.image-alt", function () {
        U && R.popups.isVisible("image.alt") && j();
      }), a;
    }
    function Q() {
      var e = R.popups.get("image.size"),
        t = U.get(0).style.height ? U.get(0).style.height : "auto",
        a = U.get(0).style.width ? U.get(0).style.width : "auto";
      if (U) if (Se()) {
        var i = U.parent();
        i.get(0).style.width || (i = U.parent().parent()), e.find('input[name="width"]').val(a).trigger("change"), e.find('input[name="height"]').val(t).trigger("change");
      } else e.find('input[name="width"]').val(a).trigger("change"), e.find('input[name="height"]').val(t).trigger("change");
    }
    function Z() {
      var e = R.popups.get("image.size");
      e || (e = ee()), k(), R.popups.refresh("image.size"), R.popups.setContainer("image.size", R.$sc);
      var t = Ce(),
        a = t.outerWidth() / 2;
      Se() && (t = t.find(".fr-img-wrap"), a = U.outerWidth() / 2);
      var i = t.outerHeight();
      R.opts.iframe && Se() && (i = U ? U.outerHeight() : 0);
      var r = t.offset().left + a,
        n = t.offset().top + t.outerHeight();
      R.popups.show("image.size", r, n, i, !0);
    }
    function ee(e) {
      if (e) return R.popups.onRefresh("image.size", Q), !0;
      var t = {
          buttons: '<div class="fr-buttons fr-tabs">'.concat(R.button.buildList(R.opts.imageSizeButtons), "</div>"),
          size_layer: '<div class="fr-image-size-layer fr-layer fr-active" id="fr-image-size-layer-'.concat(R.id, '"><div class="fr-image-group"><div class="fr-input-line"><input id="fr-image-size-layer-width-\'').concat(R.id, '" type="text" name="width" placeholder="').concat(R.language.translate("Width"), '" tabIndex="1"></div><div class="fr-input-line"><input id="fr-image-size-layer-height').concat(R.id, '" type="text" name="height" placeholder="').concat(R.language.translate("Height"), '" tabIndex="1"></div></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetSize" tabIndex="2" role="button">').concat(R.language.translate("Update"), "</button></div></div>")
        },
        a = R.popups.create("image.size", t);
      return R.$wp && R.events.$on(R.$wp, "scroll.image-size", function () {
        U && R.popups.isVisible("image.size") && Z();
      }), a;
    }
    function te(e, t, a, i) {
      return e.pageX = t, D.call(this, e), e.pageX = e.pageX + a * Math.floor(Math.pow(1.1, i)), T.call(this, e), $.call(this, e), ++i;
    }
    function ae(e) {
      if (e = e || Ce(), R.opts.trackChangesEnabled && !R.helpers.isMobile() && (!e[0].parentNode || "SPAN" !== e[0].parentNode.tagName || !e[0].parentNode.hasAttribute("data-tracking"))) return R.track_changes.removeSpecialItem(e), R.popups.hideAll(), void ce(!0);
      e && !1 !== R.events.trigger("image.beforeRemove", [e]) && (R.popups.hideAll(), we(), ce(!0), R.undo.canDo() || R.undo.saveStep(), e.get(0) == R.el ? e.removeAttr("src") : (e.get(0).parentNode && "A" == e.get(0).parentNode.tagName ? (R.selection.setBefore(e.get(0).parentNode) || R.selection.setAfter(e.get(0).parentNode) || e.parent().after(Me.MARKERS), A(e.get(0).parentNode).remove()) : (R.selection.setBefore(e.get(0)) || R.selection.setAfter(e.get(0)) || e.after(Me.MARKERS), e.remove()), R.html.fillEmptyBlocks(), R.selection.restore()), R.undo.saveStep());
    }
    function ie(e) {
      var t = e.which,
        a = document.getElementsByClassName("fs-transforms-container"),
        i = !1;
      if (a && a.length) {
        var r,
          n = Ke(a);
        try {
          for (n.s(); !(r = n.n()).done;) {
            var o = r.value;
            o.childNodes && o.childNodes.length && (i = !0);
          }
        } catch (p) {
          n.e(p);
        } finally {
          n.f();
        }
      }
      if (i && (U = null), U && (t == Me.KEYCODE.BACKSPACE || t == Me.KEYCODE.DELETE)) return e.preventDefault(), e.stopPropagation(), ae(), !1;
      if (U && t == Me.KEYCODE.ESC) {
        var s = U;
        return ce(!0), R.selection.setAfter(s.get(0)), R.selection.restore(), e.preventDefault(), !1;
      }
      if (!U || t != Me.KEYCODE.ARROW_LEFT && t != Me.KEYCODE.ARROW_RIGHT) return U && t === Me.KEYCODE.TAB ? (e.preventDefault(), e.stopPropagation(), ce(!0), !1) : U && t != Me.KEYCODE.F10 && !R.keys.isBrowserAction(e) ? (e.preventDefault(), e.stopPropagation(), !1) : void 0;
      var l = U.get(0);
      return ce(!0), t == Me.KEYCODE.ARROW_LEFT ? R.selection.setBefore(l) : R.selection.setAfter(l), R.selection.restore(), e.preventDefault(), !1;
    }
    function re(e) {
      if (e && "IMG" == e.tagName) {
        if (R.node.hasClass(e, "fr-uploading") || R.node.hasClass(e, "fr-error") ? e.parentNode.removeChild(e) : R.node.hasClass(e, "fr-draggable") && e.classList.remove("fr-draggable"), e.parentNode && e.parentNode.parentNode && R.node.hasClass(e.parentNode.parentNode, "fr-img-caption")) {
          var t = e.parentNode.parentNode;
          t.removeAttribute("contenteditable"), t.removeAttribute("draggable"), t.classList.remove("fr-draggable");
          var a = e.nextSibling;
          a && a.removeAttribute("contenteditable");
        }
      } else if (e && e.nodeType == Node.ELEMENT_NODE) for (var i = e.querySelectorAll("img.fr-uploading, img.fr-error, img.fr-draggable"), r = 0; r < i.length; r++) re(i[r]);
    }
    function ne(e) {
      if (!1 === R.events.trigger("image.beforePasteUpload", [e])) return A(e).removeAttr("data-fr-image-pasted"), !1;
      U = A(e), x(), n(), P(), U.on("load", function () {
        var t = [];
        x(), A(R.popups.get("image.insert").get(0)).find("div.fr-active.fr-error").length < 1 && P(), A(this).data("events").filter(function (e) {
          "load" === e[0] && t.push(e);
        }), t.length <= 1 && A(this).off("load");
      });
      for (var t = A(e).attr("src").split(","), a = atob(t[1]), i = [], r = 0; r < a.length; r++) i.push(a.charCodeAt(r));
      H([R.browser.safari && !R.opts.imageUploadURL ? new Blob([new Uint8Array(i)], {
        type: t[0].replace(/data\:/g, "")
      }) : new Blob([new Uint8Array(i)], {
        type: t[0].replace(/data\:/g, "").replace(/;base64/g, "")
      })], U);
    }
    function oe() {
      R.opts.imagePaste ? R.$el.find("img[data-fr-image-pasted]").each(function (e, a) {
        if (R.opts.imagePasteProcess) {
          var t = R.opts.imageDefaultWidth;
          t && "auto" != t && (t += R.opts.imageResizeWithPercent ? "%" : "px"), A(a).css("width", t).removeClass("fr-dii fr-dib fr-fir fr-fil"), he(A(a), R.opts.imageDefaultDisplay, R.opts.imageDefaultAlign);
        }
        if (0 === a.src.indexOf("data:")) ne(a);else if (0 === a.src.indexOf("blob:") || 0 === a.src.indexOf("http") && R.opts.imageUploadRemoteUrls && R.opts.imageCORSProxy) {
          var i = new Image();
          i.crossOrigin = "Anonymous", i.onload = function () {
            var e = R.o_doc.createElement("CANVAS"),
              t = e.getContext("2d");
            e.height = this.naturalHeight, e.width = this.naturalWidth, t.drawImage(this, 0, 0), setTimeout(function () {
              ne(a);
            }, 0), a.src = e.toDataURL(Me.IMAGE_TYPE);
          }, R.browser.msie && Me.IMAGE_ALLOW_REGEX.test(a.src) && (Me.IMAGE_TYPE = "image/" + a.src.split(Me.IMAGE_ALLOW_REGEX)[1]), i.src = (0 === a.src.indexOf("blob:") ? "" : "".concat(R.opts.imageCORSProxy, "/")) + a.src, 0 !== a.src.indexOf("blob:") && R.undo.saveStep();
        } else 0 !== a.src.indexOf("http") || 0 === a.src.indexOf("https://mail.google.com/mail") ? (R.selection.save(), A(a).remove(), R.selection.restore()) : A(a).removeAttr("data-fr-image-pasted");
      }) : R.$el.find("img[data-fr-image-pasted]").remove();
    }
    function se(e) {
      var t = e.target.result,
        a = R.opts.imageDefaultWidth;
      a && "auto" != a && (a += R.opts.imageResizeWithPercent ? "%" : "px"), R.undo.saveStep(), R.html.insert('<img data-fr-image-pasted="true" src="'.concat(t, '"').concat(a ? ' style="width: '.concat(a, ';"') : "", ">"));
      var i = R.$el.find('img[data-fr-image-pasted="true"]');
      i && he(i, R.opts.imageDefaultDisplay, R.opts.imageDefaultAlign), R.events.trigger("paste.after");
    }
    function le(e, t) {
      var a = new FileReader();
      a.onload = function i(e) {
        var t = R.opts.imageDefaultWidth;
        t && "auto" != t && (t += R.opts.imageResizeWithPercent ? "%" : "px"), R.html.insert('<img data-fr-image-pasted="true" src="'.concat(e, '"').concat(t ? ' style="width: '.concat(t, ';"') : "", ">"));
        var a = R.$el.find('img[data-fr-image-pasted="true"]');
        a && he(a, R.opts.imageDefaultDisplay, R.opts.imageDefaultAlign), R.events.trigger("paste.after");
      }(t), a.readAsDataURL(e, t);
    }
    function pe(e, t) {
      var a = t || e && e.clipboardData;
      if (a && a.items) {
        var i = (a || window.clipboardData).getData("text/html") || "";
        R.browser.mozilla && ("" === i || /<!--StartFragment-->([ ])<!--EndFragment-->/.test(i)) && (i = R.win.localStorage.getItem("fr-copied-html"));
        var r = new DOMParser().parseFromString(i, "text/html").querySelector("img");
        if (r && !R.opts.imageUploadURL) {
          if (!r) return !1;
          var n = r.src,
            o = null;
          if (a.types && -1 != [].indexOf.call(a.types, "text/rtf") || a.getData("text/rtf")) o = a.items[0].getAsFile();else for (var s = 0; s < a.items.length; s++) if (o = a.items[s].getAsFile()) {
            Me.IMAGE_TYPE = o.type;
            break;
          }
          if (o) return le(o, n), !1;
        } else {
          var l = null;
          if (a.types && -1 != [].indexOf.call(a.types, "text/rtf") || a.getData("text/rtf")) l = a.items[0].getAsFile();else for (var p = 0; p < a.items.length && !(l = a.items[p].getAsFile()); p++);
          if (l) return function f(e) {
            var t = new FileReader();
            t.onload = se, t.readAsDataURL(e);
          }(l), !1;
        }
      }
    }
    function fe(e) {
      return e = e.replace(/<img /gi, '<img data-fr-image-pasted="true" ');
    }
    function ge(e) {
      if ("false" == A(this).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
      if (e && "touchend" == e.type && a) return !0;
      if (e && R.edit.isDisabled()) return e.stopPropagation(), e.preventDefault(), !1;
      for (var t = 0; t < Me.INSTANCES.length; t++) Me.INSTANCES[t] != R && Me.INSTANCES[t].events.trigger("image.hideResizer");
      R.toolbar.disable(), e && (e.stopPropagation(), e.preventDefault()), R.helpers.isMobile() && (R.events.disableBlur(), R.$el.blur(), R.events.enableBlur()), R.opts.iframe && R.size.syncIframe(), U = A(this), we(), x(), n(), R.browser.msie ? (R.popups.areVisible() && R.events.disableBlur(), R.win.getSelection && (R.win.getSelection().removeAllRanges(), R.win.getSelection().addRange(R.doc.createRange()))) : R.selection.clear(), R.helpers.isIOS() && (R.events.disableBlur(), R.$el.blur()), R.button.bulkRefresh(), R.events.trigger("video.hideResizer");
    }
    function ce(e) {
      U && (function t() {
        return de;
      }() || !0 === e) && (R.toolbar.enable(), p.removeClass("fr-active"), R.popups.hideAll(), U = null, me(), f = null, g && g.hide());
    }
    r[i] = "Image cannot be loaded from the passed link.", r[d] = "No link in upload response.", r[u] = "Error during file upload.", r[m] = "Parsing response failed.", r[S] = "File is too large.", r[E] = "Image file type is invalid.", r[7] = "Files can be uploaded only to same domain in IE 8 and IE 9.";
    var de = !(r[8] = "Image file is corrupted.");
    function ue() {
      de = !0;
    }
    function me() {
      de = !1;
    }
    function he(e, t, a) {
      if (!R.opts.htmlUntouched && R.opts.useClasses) e.removeClass("fr-fil fr-fir fr-dib fr-dii"), a && e.addClass("fr-fi".concat(a[0])), t && e.addClass("fr-di".concat(t[0]));else if ("inline" == t) {
        if (e.css({
          display: "inline-block",
          verticalAlign: "bottom",
          margin: R.opts.imageDefaultMargin
        }), "center" == a) e.css({
          "float": "none",
          marginBottom: "",
          marginTop: "",
          maxWidth: "calc(100% - ".concat(2 * R.opts.imageDefaultMargin, "px)"),
          textAlign: "center"
        });else if ("left" == a) {
          var i = "0px",
            r = e.parent("span.fr-img-caption").get(0);
          r || (r = e.parent().get(0)), r && "li" === r.tagName.toLowerCase() ? i = "20px" : r && "p" === r.tagName.toLowerCase() && (i = "15px"), e.css({
            "float": "left",
            marginLeft: 0,
            maxWidth: "calc(100% - ".concat(R.opts.imageDefaultMargin, "px)"),
            textAlign: "left",
            marginRight: i
          });
        } else e.css({
          "float": "right",
          marginRight: 0,
          maxWidth: "calc(100% - ".concat(R.opts.imageDefaultMargin, "px)"),
          textAlign: "right"
        });
      } else "block" == t && (e.css({
        display: "block",
        "float": "none",
        verticalAlign: "top",
        margin: "".concat(R.opts.imageDefaultMargin, "px auto"),
        textAlign: "center"
      }), "left" == a ? e.css({
        marginLeft: 0,
        textAlign: "left"
      }) : "right" == a && e.css({
        marginRight: 0,
        textAlign: "right"
      }));
    }
    function ve(e) {
      if (void 0 === e && (e = Ce()), e) {
        if (e.hasClass("fr-fil")) return "left";
        if (e.hasClass("fr-fir")) return "right";
        if (e.hasClass("fr-dib") || e.hasClass("fr-dii")) return "center";
        var t = e.css("float");
        if (e.css("float", "none"), "block" == e.css("display")) {
          if (e.css("float", ""), e.css("float") != t && e.css("float", t), 0 === parseInt(e.css("margin-left"), 10)) return "left";
          if (0 === parseInt(e.css("margin-right"), 10)) return "right";
        } else {
          if (e.css("float", ""), e.css("float") != t && e.css("float", t), "left" == e.css("float")) return "left";
          if ("right" == e.css("float")) return "right";
        }
      }
      return "center";
    }
    function be(e) {
      void 0 === e && (e = Ce());
      var t = e.css("float");
      return e.css("float", "none"), "block" == e.css("display") ? (e.css("float", ""), e.css("float") != t && e.css("float", t), "block") : (e.css("float", ""), e.css("float") != t && e.css("float", t), "inline");
    }
    function ye() {
      var e = R.popups.get("image.insert");
      e || (e = X()), R.popups.isVisible("image.insert") || (k(), R.popups.refresh("image.insert"), R.popups.setContainer("image.insert", R.$sc));
      var t = Ce(),
        a = t && t.outerWidth() / 2;
      Se() && (t = t.find(".fr-img-wrap"), a = U.outerWidth() / 2);
      var i,
        r = t.offset().left + a,
        n = t.outerHeight(!0);
      R.opts.iframe && Se() && (n = U ? U.outerHeight() : 0), i = 0 < R.$el.find("img[data-fr-image-pasted]").length ? R.$wp.offset().top - R.helpers.scrollTop() + R.$wp.height() : t.offset().top + t.outerHeight(), R.popups.show("image.insert", r, i, n, !0);
    }
    function we() {
      if (U) {
        R.events.disableBlur(), R.selection.clear();
        var e = R.doc.createRange();
        e.selectNode(U.get(0)), R.browser.msie && e.collapse(!0), R.selection.get().addRange(e), R.events.enableBlur();
      }
    }
    function Ae() {
      return U;
    }
    function Ce() {
      return Se() ? U.parents(".fr-img-caption").first() : U;
    }
    function Se() {
      return !!U && 0 < U.parents(".fr-img-caption").length;
    }
    function Ee(e) {
      for (var t = document.createDocumentFragment(); e.firstChild;) {
        var a = e.removeChild(e.firstChild);
        t.appendChild(a);
      }
      e.parentNode.replaceChild(t, e);
    }
    return {
      _init: function Re() {
        var n;
        (function e() {
          R.events.$on(R.$el, R._mousedown, "IMG" == R.el.tagName ? null : 'img:not([contenteditable="false"])', function (e) {
            if ("false" == A(this).parents("contenteditable").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
            R.helpers.isMobile() || R.selection.clear(), t = !0, R.popups.areVisible() && R.events.disableBlur(), R.browser.msie && (R.events.disableBlur(), R.$el.attr("contenteditable", !1)), R.draggable || "touchstart" == e.type || e.preventDefault(), e.stopPropagation();
          }), R.events.$on(R.$el, R._mousedown, ".fr-img-caption .fr-inner", function (e) {
            R.core.hasFocus() || R.events.focus(), e.stopPropagation();
          }), R.events.$on(R.$el, "paste", ".fr-img-caption .fr-inner", function (e) {
            !0 === R.opts.toolbarInline && (R.toolbar.hide(), e.stopPropagation());
          }), R.events.$on(R.$el, R._mousedown, 'img:not([contenteditable="false"])', function (e) {
            var t = this;
            R.browser.mozilla && 3 == e.which && (A(this).attr("contenteditable", !1), setTimeout(function () {
              A(t).removeAttr("contenteditable");
            }, 200));
          }), R.events.$on(R.$el, R._mouseup, "IMG" == R.el.tagName ? null : 'img:not([contenteditable="false"])', function (e) {
            if ("false" == A(this).parents("contenteditable").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
            t && (t = !1, e.stopPropagation(), R.browser.msie && (R.$el.attr("contenteditable", !0), R.events.enableBlur()));
          }), R.events.on("keyup", function (e) {
            if (e.shiftKey && "" === R.selection.text().replace(/\n/g, "") && R.keys.isArrow(e.which)) {
              var t = R.selection.element(),
                a = R.selection.endElement();
              t && "IMG" == t.tagName ? z(A(t)) : a && "IMG" == a.tagName && z(A(a));
            }
          }, !0), R.events.on("drop", V), R.events.on("element.beforeDrop", F), R.events.on("mousedown window.mousedown", ue), R.events.on("window.touchmove", me), R.events.on("mouseup window.mouseup", function () {
            if (U && !R.helpers.isMobile()) return ce(), !1;
            me();
          }), R.events.on("touchstart touchend", function () {
            if (U && R.helpers.isMobile()) return ce(), !1;
            me();
          }), R.events.on("commands.mousedown", function (e) {
            0 < e.parents(".fr-toolbar").length && ce();
          }), R.events.on("image.resizeEnd", function () {
            R.opts.iframe && R.size.syncIframe();
          }), R.events.on("blur image.hideResizer commands.undo commands.redo element.dropped", function () {
            ce(!(t = !1));
          }), R.events.on("modals.hide", function () {
            U && (we(), R.selection.clear());
          }), R.events.on("image.resizeEnd", function () {
            R.win.getSelection && z(U);
          }), R.events.on("filestack-init", function () {
            X();
          }), R.events.on("filestack-init-edit", function () {
            for (var e = R.$(".fr-popup:not(.fr-do-not-hide)"), t = e.length - 1; 0 <= t; t--) e[t].parentElement.removeChild(e[t]);
            N();
          }), R.opts.imageAddNewLine && R.events.on("image.inserted", function (e) {
            var t = e.get(0);
            for (t.nextSibling && "BR" === t.nextSibling.tagName && (t = t.nextSibling); t && !R.node.isElement(t);) t = R.node.isLastSibling(t) ? t.parentNode : null;
            R.node.isElement(t) && (R.opts.enter === Me.ENTER_BR ? e.after("<br>") : A(R.node.blockParent(e.get(0))).after("<".concat(R.html.defaultTag(), "><br></").concat(R.html.defaultTag(), ">")));
          });
        })(), "IMG" == R.el.tagName && R.$el.addClass("fr-view"), R.events.$on(R.$el, R.helpers.isMobile() && !R.helpers.isWindowsPhone() ? "touchend" : "click", "IMG" == R.el.tagName ? null : 'img:not([contenteditable="false"])', ge), R.helpers.isMobile() && (R.events.$on(R.$el, "touchstart", "IMG" == R.el.tagName ? null : 'img:not([contenteditable="false"])', function () {
          a = !1;
        }), R.events.$on(R.$el, "touchmove", function () {
          a = !0;
        })), R.$wp ? (R.events.on("window.keydown keydown", ie, !0), R.events.on("keyup", function (e) {
          if (U && e.which == Me.KEYCODE.ENTER) return !1;
        }, !0), R.events.$on(R.$el, "keydown", function () {
          var e = R.selection.element();
          (e.nodeType === Node.TEXT_NODE || "BR" == e.tagName && R.node.isLastSibling(e)) && (e = e.parentNode), R.node.hasClass(e, "fr-inner") || (R.node.hasClass(e, "fr-img-caption") || (e = A(e).parents(".fr-img-caption").get(0)), R.node.hasClass(e, "fr-img-caption") && (R.opts.trackChangesEnabled || A(e).after(Me.INVISIBLE_SPACE + Me.MARKERS), R.selection.restore()));
        })) : R.events.$on(R.$win, "keydown", ie), R.events.on("toolbar.esc", function () {
          if (U) {
            if (R.$wp) R.events.disableBlur(), R.events.focus();else {
              var e = U;
              ce(!0), R.selection.setAfter(e.get(0)), R.selection.restore();
            }
            return !1;
          }
        }, !0), R.events.on("toolbar.focusEditor", function () {
          if (U) return !1;
        }, !0), R.events.on("window.cut window.copy", function (e) {
          if (U && R.popups.isVisible("image.edit") && !R.popups.get("image.edit").find(":focus").length) {
            var t = Ce();
            Se() ? (t.before(Me.START_MARKER), t.after(Me.END_MARKER), R.selection.restore(), R.paste.saveCopiedText(t.get(0).outerHTML, t.text())) : (we(), R.paste.saveCopiedText(U.get(0).outerHTML, U.attr("alt"))), "copy" == e.type ? setTimeout(function () {
              z(U);
            }) : (ce(!0), R.undo.saveStep(), setTimeout(function () {
              R.undo.saveStep();
            }, 0));
          }
        }, !0), R.browser.msie && R.events.on("keydown", function (e) {
          if (!R.selection.isCollapsed() || !U) return !0;
          var t = e.which;
          t == Me.KEYCODE.C && R.keys.ctrlKey(e) ? R.events.trigger("window.copy") : t == Me.KEYCODE.X && R.keys.ctrlKey(e) && R.events.trigger("window.cut");
        }), R.events.$on(A(R.o_win), "keydown", function (e) {
          if (R.opts.pluginsEnabled.includes("filestack") && R.opts.iframe) {
            var t = document.getElementsByClassName("fs-transforms-container"),
              a = !1;
            if (t && t.length) {
              var i,
                r = Ke(t);
              try {
                for (r.s(); !(i = r.n()).done;) {
                  var n = i.value;
                  n.childNodes && n.childNodes.length && (a = !0);
                }
              } catch (s) {
                r.e(s);
              } finally {
                r.f();
              }
            }
            a && (U = null);
          }
          var o = e.which;
          if (U && o == Me.KEYCODE.BACKSPACE) return e.preventDefault(), !1;
        }), R.events.$on(R.$win, "keydown", function (e) {
          var t = e.which;
          U && U.hasClass("fr-uploading") && t == Me.KEYCODE.ESC && U.trigger("abortUpload");
        }), R.events.on("destroy", function () {
          U && U.hasClass("fr-uploading") && U.trigger("abortUpload");
        }), R.events.on("paste.before", pe), R.events.on("paste.beforeCleanup", fe), R.events.on("paste.after", oe), R.events.on("html.set", l), R.events.on("html.inserted", l), l(), R.events.on("destroy", function () {
          c = [];
        }), R.events.on("html.processGet", re), R.opts.imageOutputSize && R.events.on("html.beforeGet", function () {
          n = R.el.querySelectorAll("img");
          for (var e = 0; e < n.length; e++) {
            var t = parseFloat(A(n[e]).css("padding-left")) + parseFloat(A(n[e]).css("padding-right")),
              a = A(n[e]).width() - t,
              i = n[e].style.width || a,
              r = n[e].style.height || A(n[e]).height();
            i && n[e].setAttribute("width", "".concat(i).replace(/px/, "")), r && n[e].setAttribute("height", "".concat(r).replace(/px/, ""));
          }
        }), R.opts.iframe && R.events.on("image.loaded", R.size.syncIframe), R.$wp && (b(), R.events.on("contentChanged", b)), R.events.$on(A(R.o_win), "orientationchange.image", function () {
          setTimeout(function () {
            U && z(U);
          }, 100);
        }), N(!0), X(!0), ee(!0), J(!0), R.events.on("node.remove", function (e) {
          if ("IMG" == e.get(0).tagName) return ae(e), !1;
        });
      },
      showInsertPopup: function Ue() {
        var e = R.$tb.find('.fr-command[data-cmd="insertImage"]'),
          t = R.popups.get("image.insert");
        if (t || (t = X()), k(), !t.hasClass("fr-active")) if (R.popups.refresh("image.insert"), R.popups.setContainer("image.insert", R.$tb), e.isVisible()) {
          var a = R.button.getPosition(e),
            i = a.left,
            r = a.top;
          R.popups.show("image.insert", i, r, e.outerHeight());
        } else R.position.forSelection(t), R.popups.show("image.insert");
      },
      showLayer: function xe(e) {
        var t,
          a,
          i = R.popups.get("image.insert");
        if (U || R.opts.toolbarInline) {
          if (U) {
            var r = Ce(),
              n = 0;
            Se() && (r = r.find(".fr-img-wrap"), n = U.outerWidth() / 2), a = r.offset().top + r.outerHeight(), t = r.offset().left + n;
          }
        } else {
          var o = R.$tb.find('.fr-command[data-cmd="insertImage"]');
          t = o.offset().left, a = o.offset().top + (R.opts.toolbarBottom ? 10 : o.outerHeight() - 10);
        }
        !U && R.opts.toolbarInline && (a = i.offset().top - R.helpers.getPX(i.css("margin-top")), i.hasClass("fr-above") && (a += i.outerHeight())), i.find(".fr-layer").removeClass("fr-active"), i.find(".fr-".concat(e, "-layer")).addClass("fr-active"), R.popups.show("image.insert", t, a, U ? U.outerHeight() : 0, Se()), R.accessibility.focusPopup(i);
      },
      refreshUploadButton: function De(e) {
        var t = R.popups.get("image.insert");
        t && t.find(".fr-image-upload-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0);
      },
      refreshByURLButton: function Te(e) {
        var t = R.popups.get("image.insert");
        t && t.find(".fr-image-by-url-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0);
      },
      upload: H,
      insertByURL: function $e() {
        var e = R.popups.get("image.insert").find(".fr-image-by-url-layer input");
        if (0 < e.val().length) {
          P(), B(R.language.translate("Loading image"));
          var t = e.val().trim();
          if (R.opts.imageUploadRemoteUrls && R.opts.imageCORSProxy && R.opts.imageUpload) {
            var a = new XMLHttpRequest();
            a.onload = function () {
              200 == this.status ? H([new Blob([this.response], {
                type: this.response.type || "image/png"
              })], U) : I(i);
            }, a.onerror = function () {
              _(t, !0, [], U);
            }, a.open("GET", "".concat(R.opts.imageCORSProxy, "/").concat(t), !0), a.responseType = "blob", a.send();
          } else _(t, !0, [], U);
          e.val(""), e.blur();
        }
      },
      align: function Ie(e) {
        var t = Ce();
        t.removeClass("fr-fir fr-fil"), !R.opts.htmlUntouched && R.opts.useClasses ? "left" == e ? t.addClass("fr-fil") : "right" == e && t.addClass("fr-fir") : he(t, be(), e), we(), x(), n(), R.selection.clear();
      },
      refreshAlign: function Ne(e) {
        U && e.find("> *").first().replaceWith(R.icon.create("image-align-".concat(ve())));
      },
      refreshAlignOnShow: function Pe(e, t) {
        U && t.find('.fr-command[data-param1="'.concat(ve(), '"]')).addClass("fr-active").attr("aria-selected", !0);
      },
      display: function ke(e) {
        var t = Ce();
        t.removeClass("fr-dii fr-dib"), !R.opts.htmlUntouched && R.opts.useClasses ? "inline" == e ? t.addClass("fr-dii") : "block" == e && t.addClass("fr-dib") : he(t, e, ve()), we(), x(), n(), R.selection.clear();
      },
      refreshDisplayOnShow: function Be(e, t) {
        U && t.find('.fr-command[data-param1="'.concat(be(), '"]')).addClass("fr-active").attr("aria-selected", !0);
      },
      replace: ye,
      back: function e() {
        U ? (R.events.disableBlur(), A(".fr-popup input:focus").blur(), z(U)) : (R.events.disableBlur(), R.selection.restore(), R.events.enableBlur(), R.popups.hide("image.insert"), R.toolbar.showInline());
      },
      get: Ae,
      getEl: Ce,
      insert: _,
      showProgressBar: P,
      remove: ae,
      hideProgressBar: k,
      applyStyle: function Oe(e, t, a) {
        if (void 0 === t && (t = R.opts.imageStyles), void 0 === a && (a = R.opts.imageMultipleStyles), !U) return !1;
        var i = Ce();
        if (!a) {
          var r = Object.keys(t);
          r.splice(r.indexOf(e), 1), i.removeClass(r.join(" "));
        }
        "object" == We(t[e]) ? (i.removeAttr("style"), i.css(t[e].style)) : (i.toggleClass(e), Se() && U.hasClass(e) && U.removeClass(e)), z(U);
      },
      showAltPopup: j,
      showSizePopup: Z,
      setAlt: function ze(e) {
        if (U) {
          var t = R.popups.get("image.alt");
          U.attr("alt", e || t.find("input").val() || ""), t.find("input:focus").blur(), z(U);
        }
      },
      setSize: function Le(e, t) {
        if (U) {
          var a = R.popups.get("image.size");
          e = e || a.find('input[name="width"]').val() || "", t = t || a.find('input[name="height"]').val() || "";
          var i = /^[\d]+((px)|%)*$/g;
          U.removeAttr("width").removeAttr("height"), e.match(i) ? U.css("width", e) : U.css("width", ""), t.match(i) ? U.css("height", t) : U.css("height", ""), Se() && (U.parents(".fr-img-caption").removeAttr("width").removeAttr("height"), e.match(i) ? U.parents(".fr-img-caption").css("width", e) : U.parents(".fr-img-caption").css("width", ""), t.match(i) ? U.parents(".fr-img-caption").css("height", t) : U.parents(".fr-img-caption").css("height", "")), a && a.find("input:focus").blur(), z(U);
        }
      },
      toggleCaption: function _e() {
        var e,
          t = R.$el.get(0),
          a = ["fr-dii", "fr-dib", "fr-fil", "fr-fir"];
        if (U && !Se()) {
          (e = U).parent().is("a") && (e = U.parent());
          var i = U.parents("ul") && 0 < U.parents("ul").length ? U.parents("ul") : U.parents("ol") && 0 < U.parents("ol").length ? U.parents("ol") : [];
          if (0 < i.length) {
            var r = i.find("li").length,
              n = U.parents("li"),
              o = document.createElement("li");
            r - 1 === n.index() && (i.append(o), o.innerHTML = "&nbsp;");
          }
          var s,
            l,
            p = (U.attr("class") || "").split(/\s+/),
            f = p.filter(function (e) {
              return a.includes(e);
            });
          U.attr("class", p.filter(function (e) {
            return !a.includes(e);
          }).join(" ")), e.attr("style") ? l = -1 < (s = e.attr("style").split(":")).indexOf("width") ? s[s.indexOf("width") + 1].replace(";", "") : "" : e.attr("width") && (l = e.attr("width"));
          var g = R.opts.imageResizeWithPercent ? (-1 < l.indexOf("px") ? null : l) || "100%" : U.width() + "px";
          e.wrap('<div class="fr-img-space-wrap"><span ' + (R.browser.mozilla ? "" : 'contenteditable="false"') + 'class="fr-img-caption ' + f.join(" ") + '" style="' + (e.attr("style") || "") + '" draggable="false"></span></div>'), e.wrap('<span class="fr-img-wrap"></span>'), U.after('<span class="fr-inner"'.concat(R.browser.mozilla ? "" : ' contenteditable="true"', ">").concat(Me.START_MARKER).concat(R.language.translate("Image Caption")).concat(Me.END_MARKER, "</span>")), U.parents(".fr-img-caption").css("width", g);
          var c = U.parents(".fr-img-space-wrap").length;
          1 == c ? Ee(t.querySelector(".fr-img-space-wrap")) : 1 < c && (Ee(t.querySelector(".fr-img-space-wrap")), Ee(t.querySelector(".fr-img-space-wrap2"))), ce(!0), R.selection.restore();
        } else {
          if (e = Ce(), U.insertBefore(e), null !== e[0].querySelector("a")) {
            for (var d, u = e[0].querySelector("a"), m = document.createElement("a"), h = 0, v = u.attributes, b = v.length; h < b; h++) d = v[h], m.setAttribute(d.nodeName, d.nodeValue);
            U.wrap(m);
          }
          var y = (e.attr("class") || "").split(/\s+/),
            w = ["fr-img-caption"],
            A = y.filter(function (e) {
              return !w.includes(e);
            }),
            C = (U.attr("class") || "").split(/\s+/),
            S = Ye(new Set(C.concat(A)));
          U.attr("class", S.join(" ")).attr("style", e.attr("style")), e.remove();
          var E = U.parents(".fr-img-space-wrap").length;
          1 == E ? Ee(t.querySelector(".fr-img-space-wrap")) : 1 < E && (Ee(t.querySelector(".fr-img-space-wrap")), Ee(t.querySelector(".fr-img-space-wrap2"))), z(U);
        }
      },
      hasCaption: Se,
      exitEdit: ce,
      edit: z
    };
  }, Me.DefineIcon("insertImage", {
    NAME: "image",
    SVG_KEY: "insertImage"
  }), Me.RegisterShortcut(Me.KEYCODE.P, "insertImage", null, "P"), Me.RegisterCommand("insertImage", {
    title: "Insert Image",
    undo: !1,
    focus: !0,
    refreshAfterCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("image.insert") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("image.insert")) : this.image.showInsertPopup();
    },
    plugin: "image"
  }), Me.DefineIcon("imageUpload", {
    NAME: "upload",
    SVG_KEY: "upload"
  }), Me.RegisterCommand("imageUpload", {
    title: "Upload Image",
    undo: !1,
    focus: !1,
    toggle: !0,
    callback: function () {
      this.image.showLayer("image-upload");
    },
    refresh: function (e) {
      this.image.refreshUploadButton(e);
    }
  }), Me.DefineIcon("imageByURL", {
    NAME: "link",
    SVG_KEY: "insertLink"
  }), Me.RegisterCommand("imageByURL", {
    title: "By URL",
    undo: !1,
    focus: !1,
    toggle: !0,
    callback: function () {
      this.image.showLayer("image-by-url");
    },
    refresh: function (e) {
      this.image.refreshByURLButton(e);
    }
  }), Me.RegisterCommand("imageInsertByURL", {
    title: "Insert Image",
    undo: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.image.insertByURL();
    },
    refresh: function (e) {
      this.image.get() ? e.text(this.language.translate("Replace")) : e.text(this.language.translate("Insert"));
    }
  }), Me.DefineIcon("imageDisplay", {
    NAME: "star",
    SVG_KEY: "imageDisplay"
  }), Me.RegisterCommand("imageDisplay", {
    title: "Display",
    type: "dropdown",
    options: {
      inline: "Inline",
      block: "Break Text"
    },
    callback: function (e, t) {
      this.image.display(t);
    },
    refresh: function (e) {
      this.opts.imageTextNear || e.addClass("fr-hidden");
    },
    refreshOnShow: function (e, t) {
      this.image.refreshDisplayOnShow(e, t);
    }
  }), Me.DefineIcon("image-align", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }), Me.DefineIcon("image-align-left", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }), Me.DefineIcon("image-align-right", {
    NAME: "align-right",
    SVG_KEY: "alignRight"
  }), Me.DefineIcon("image-align-center", {
    NAME: "align-justify",
    SVG_KEY: "alignCenter"
  }), Me.DefineIcon("imageAlign", {
    NAME: "align-justify",
    SVG_KEY: "alignJustify"
  }), Me.RegisterCommand("imageAlign", {
    type: "dropdown",
    title: "Align",
    options: {
      left: "Align Left",
      center: "Align Center",
      right: "Align Right"
    },
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">',
        t = Me.COMMANDS.imageAlign.options;
      for (var a in t) t.hasOwnProperty(a) && (e += '<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="imageAlign" data-param1="'.concat(a, '" title="').concat(this.language.translate(t[a]), '">').concat(this.icon.create("image-align-".concat(a)), '<span class="fr-sr-only">').concat(this.language.translate(t[a]), "</span></a></li>"));
      return e += "</ul>";
    },
    callback: function (e, t) {
      this.image.align(t);
    },
    refresh: function (e) {
      this.image.refreshAlign(e);
    },
    refreshOnShow: function (e, t) {
      this.image.refreshAlignOnShow(e, t);
    }
  }), Me.DefineIcon("imageReplace", {
    NAME: "exchange",
    FA5NAME: "exchange-alt",
    SVG_KEY: "replaceImage"
  }), Me.RegisterCommand("imageReplace", {
    title: "Replace",
    undo: !1,
    focus: !1,
    popup: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.image.replace();
    }
  }), Me.DefineIcon("imageRemove", {
    NAME: "trash",
    SVG_KEY: "remove"
  }), Me.RegisterCommand("imageRemove", {
    title: "Remove",
    callback: function () {
      this.image.remove();
    }
  }), Me.DefineIcon("imageBack", {
    NAME: "arrow-left",
    SVG_KEY: "back"
  }), Me.RegisterCommand("imageBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    callback: function () {
      this.image.back();
    },
    refresh: function (e) {
      this.$;
      this.image.get() || this.opts.toolbarInline ? (e.removeClass("fr-hidden"), e.next(".fr-separator").removeClass("fr-hidden")) : (e.addClass("fr-hidden"), e.next(".fr-separator").addClass("fr-hidden"));
    }
  }), Me.RegisterCommand("imageDismissError", {
    title: "OK",
    undo: !1,
    callback: function () {
      this.image.hideProgressBar(!0);
    }
  }), Me.DefineIcon("imageStyle", {
    NAME: "magic",
    SVG_KEY: "imageClass"
  }), Me.RegisterCommand("imageStyle", {
    title: "Style",
    type: "dropdown",
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">',
        t = this.opts.imageStyles;
      for (var a in t) if (t.hasOwnProperty(a)) {
        var i = t[a];
        "object" == We(i) && (i = i.title), e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="imageStyle" data-param1="'.concat(a, '">').concat(this.language.translate(i), "</a></li>");
      }
      return e += "</ul>";
    },
    callback: function (e, t) {
      this.image.applyStyle(t);
    },
    refreshOnShow: function (e, t) {
      var a = this.$,
        i = this.image.getEl();
      i && t.find(".fr-command").each(function () {
        var e = a(this).data("param1"),
          t = i.hasClass(e);
        a(this).toggleClass("fr-active", t).attr("aria-selected", t);
      });
    }
  }), Me.DefineIcon("imageAlt", {
    NAME: "info",
    SVG_KEY: "imageAltText"
  }), Me.RegisterCommand("imageAlt", {
    undo: !1,
    focus: !1,
    popup: !0,
    title: "Alternative Text",
    callback: function () {
      this.image.showAltPopup();
    }
  }), Me.RegisterCommand("imageSetAlt", {
    undo: !0,
    focus: !1,
    title: "Update",
    refreshAfterCallback: !1,
    callback: function () {
      this.image.setAlt();
    }
  }), Me.DefineIcon("imageSize", {
    NAME: "arrows-alt",
    SVG_KEY: "imageSize"
  }), Me.RegisterCommand("imageSize", {
    undo: !1,
    focus: !1,
    popup: !0,
    title: "Change Size",
    callback: function () {
      this.image.showSizePopup();
    }
  }), Me.RegisterCommand("imageSetSize", {
    undo: !0,
    focus: !1,
    title: "Update",
    refreshAfterCallback: !1,
    callback: function () {
      this.image.setSize();
    }
  }), Me.DefineIcon("imageCaption", {
    NAME: "commenting",
    FA5NAME: "comment-alt",
    SVG_KEY: "imageCaption"
  }), Me.RegisterCommand("imageCaption", {
    undo: !0,
    focus: !1,
    title: "Image Caption",
    refreshAfterCallback: !0,
    callback: function () {
      this.image.toggleCaption();
    },
    refresh: function (e) {
      this.image.get() && e.toggleClass("fr-active", this.image.hasCaption());
    }
  });
});